import { render, staticRenderFns } from "./ServiceObjectMaintenanceNotesFastFix.vue?vue&type=template&id=0f874a4e&"
import script from "./ServiceObjectMaintenanceNotesFastFix.vue?vue&type=script&lang=js&"
export * from "./ServiceObjectMaintenanceNotesFastFix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QSeparator,QCardActions,QBtn,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QSeparator,QCardActions,QBtn,QInnerLoading,QSpinnerGears}, component.options.components || {})
